module.exports = __webpack_public_path__ + "static/media/viberArticle.c50c423a.svg";